module.exports = __webpack_public_path__ + "img/stepper.4c25edd4.svg";